import React from 'react';

type DownloadPdfActionIconProps = {
  className?: string;
};

export default function DownloadPdfActionIcon({ className }: DownloadPdfActionIconProps) {
  const classes = ['download-pdf-icon', className].filter(Boolean).join(' ');

  return (
    <svg
      className={classes}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      width="12"
      height="10"
      viewBox="0 0 17 15"
      fill="none"
    >
      <path
        d="M1.0625 2.125C1.0625 1.5373 1.5373 1.0625 2.125 1.0625H6.24551C6.52773 1.0625 6.79668 1.17539 6.9959 1.37461L8.18789 2.5666C8.58633 2.96504 9.12754 3.1875 9.69199 3.1875H14.875C15.4627 3.1875 15.9375 3.6623 15.9375 4.25V12.75C15.9375 13.3377 15.4627 13.8125 14.875 13.8125H2.125C1.5373 13.8125 1.0625 13.3377 1.0625 12.75V2.125ZM2.125 0C0.95293 0 0 0.95293 0 2.125V12.75C0 13.9221 0.95293 14.875 2.125 14.875H14.875C16.0471 14.875 17 13.9221 17 12.75V4.25C17 3.07793 16.0471 2.125 14.875 2.125H9.69199C9.40977 2.125 9.14082 2.01211 8.9416 1.81289L7.74961 0.620898C7.35117 0.222461 6.80996 0 6.24551 0H2.125ZM9.03125 5.84375C9.03125 5.55156 8.79219 5.3125 8.5 5.3125C8.20781 5.3125 7.96875 5.55156 7.96875 5.84375V9.87461L6.21895 8.12481C6.01309 7.91895 5.67441 7.91895 5.46855 8.12481C5.2627 8.33066 5.2627 8.66934 5.46855 8.87519L8.1248 11.5314C8.33066 11.7373 8.66934 11.7373 8.87519 11.5314L11.5314 8.87519C11.7373 8.66934 11.7373 8.33066 11.5314 8.12481C11.3256 7.91895 10.9869 7.91895 10.7811 8.12481L9.03125 9.87461V5.84375Z"
        fill="#424242"
      />
    </svg>
  );
}
